<div
    class="px-4"
    [style.font-family]="plainFont()"
    [style.color]="textColor()"
    [style.background]="backgroundColor()"
    [style.padding-top.px]="paddingTop()"
    [style.padding-bottom.px]="paddingBottom()"
    [style.text-align]="textAlign()"
>
  @if (widget()?.title || widget()?.subtitle) {
    <div class="mb-3">
      @if (widget()?.title) {
        <div class="title" [style.color]="titleColor()" [style.font-family]="titleFont()">
          {{ widget()?.title }}
        </div>
      }
      @if (widget()?.subtitle) {
        <div class="subtitle" [style.color]="subtitleColor()" [style.font-family]="subtitleFont()">
          {{ widget()?.subtitle }}
        </div>
      }
    </div>
  }
   
  @if (fg(); as formGroup) {
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" novalidate class="space-y-6">
    @if (!success()) {
        @for (section of widget()?.sections ?? []; track section.id) {
        <div class="space-y-3">
            @if (section.title) {
            <div class="font-semibold" [style.font-family]="titleFont()" [style.color]="subtitleColor()">{{ section.title }}</div>
            }

            <div class="space-y-3">
            @for (field of section.fields; track field.id) {
            <div class="space-y-1" [class.text-red-600]="showError(section.id, field)">
                <!-- label for all non-boolean fields -->
                @if (field.type !== 'boolean') {
                <label class="text-sm font-medium" [class.text-red-600]="showError(section.id, field)">
                    {{ field.title }}
                    @if (field.mandatory) { <span class="opacity-80">*</span> }
                </label>
                }

                <!-- TEXT -->
                @if (field.type === 'text') {
                <input
                type="text"
                class="block w-full rounded-md border bg-transparent px-3 py-2 mt-2
                        focus:outline-none focus:border-current/50"
                [class.border-red-500]="showError(section.id, field)"
                [style.border-radius.px]="cornerRadius()"
                [formControlName]="ctrlName(section.id, field)"
                autocomplete="off"
                />

                }

                <!-- LONGTEXT -->
                @if (field.type === 'longText') {
                <textarea
                    rows="4"
                    class="block w-full rounded-md border bg-transparent px-3 py-2 mt-2
                        focus:outline-none focus:border-current/50 resize-y"
                    [class.border-red-500]="showError(section.id, field)"
                    [style.border-radius.px]="cornerRadius()"
                    [formControlName]="ctrlName(section.id, field)"
                ></textarea>
                }

                <!-- NUMBER -->
                @if (field.type === 'number') {
                <input
                    type="number"
                    step="1"
                    class="block w-full rounded-md border bg-transparent px-3 py-2 mt-2
                        focus:outline-none focus:border-current/50"
                    [class.border-red-500]="showError(section.id, field)"
                    [style.border-radius.px]="cornerRadius()"
                    [formControlName]="ctrlName(section.id, field)"
                    (keydown)="validateNumberKeys($event)"
                />
                }

                <!-- DECIMAL -->
                @if (field.type === 'decimal') {
                <input
                    type="number"
                    step="0.1"
                    class="block w-full rounded-md border bg-transparent px-3 py-2 mt-2
                        focus:outline-none focus:border-current/50"
                    [class.border-red-500]="showError(section.id, field)"
                    [style.border-radius.px]="cornerRadius()"
                    [formControlName]="ctrlName(section.id, field)"
                    (keydown)="validateDecimalKeys($event)"
                />
                }

                <!-- DATE -->
                @if (field.type === 'date') {
                <input
                    type="date"
                    class="block w-full rounded-md border bg-transparent px-3 py-2 mt-2
                        focus:outline-none focus:border-current/50"
                    [class.border-red-500]="showError(section.id, field)"
                    [style.border-radius.px]="cornerRadius()"
                    [formControlName]="ctrlName(section.id, field)"
                />
                }

                <!-- TIME -->
                @if (field.type === 'time') {
                <input
                    type="time"
                    class="block w-full rounded-md border bg-transparent px-3 py-2 mt-2
                        focus:outline-none focus:border-current/50"
                    [class.border-red-500]="showError(section.id, field)"
                    [style.border-radius.px]="cornerRadius()"
                    [formControlName]="ctrlName(section.id, field)"
                />
                }

                <!-- DATETIME -->
                @if (field.type === 'dateTime') {
                <input
                    type="datetime-local"
                    class="block w-full rounded-md border bg-transparent px-3 py-2 mt-2
                        focus:outline-none focus:border-current/50"
                    [style.border-radius.px]="cornerRadius()"
                    [formControlName]="ctrlName(section.id, field)"
                />
                }

                <!-- OPTIONS -->
                @if (field.type === 'options') {
                    <div class="relative">
                        <select
                            class="block w-full rounded-md border bg-transparent px-3 py-2
                                focus:outline-none focus:border-current/50
                                appearance-none pr-9"
                            [class.border-red-500]="showError(section.id, field)"
                            [style.border-radius.px]="cornerRadius()"
                            [style.background]="backgroundColor()"
                            [formControlName]="ctrlName(section.id, field)"
                        >
                            <option value="">—</option>
                            @for (opt of fieldOptions(field); track trackOption(opt)) {
                            <option [value]="optionValue(opt)">{{ optionTitle(opt) }}</option>
                            }
                        </select>
                        <svg
                            class="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 opacity-60"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                            <path
                            fill-rule="evenodd"
                            d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 011.08 1.04l-4.25 4.25a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z"
                            clip-rule="evenodd"
                            />
                        </svg>
                    </div>
                }

                <!-- BOOLEAN as toggle -->
                <!-- @if (field.type === 'boolean') {
                    <label
                        class="flex items-center justify-between rounded-md border border-black/20 bg-transparent px-3 py-2 cursor-pointer select-none"
                        [style.border-radius.px]="cornerRadius()"
                        style="margin-top: 20px!important;"
                    >
                        <span class="text-sm font-medium">
                        {{ field.title }}
                        @if (field.mandatory) { <span class="opacity-80">*</span> }
                        </span>

                        <span class="relative inline-flex items-center">
                        <input
                            type="checkbox"
                            class="sr-only peer"
                            [formControlName]="section.id + '.' + field.id"
                        />
                        <span
                            class="block h-5 w-9 rounded-full bg-black/20 transition-colors duration-150 ease-out
                                peer-checked:bg-orange-500"
                        ></span>
                        <span
                            class="pointer-events-none absolute left-0.5 h-4 w-4 rounded-full bg-white shadow
                                transition-transform duration-150 ease-out
                                peer-checked:translate-x-4"
                        ></span>
                        </span>
                    </label>
                } -->

                @if (field.type === 'boolean') {
                    <div
                        class="flex items-center justify-between rounded-md border py-2 px-3"
                        [class.border-red-500]="showError(section.id, field)"
                        [class.bg-red-50]="showError(section.id, field)"
                        style="margin-top: 20px!important;"
                    >
                        
                            @if (field?.showValueAsLabel) {
                                <div class="markdown" 
                                    [style.--font-plain]="plainFont()"
                                    [style.--font-bold]="boldFont()"
                                    [style.--font-italic]="italicFont()"
                                    [style.--accent]="accent()"
                                    [innerHTML]="getMarkdownFromField(field)">

                                </div>

                            }@else {
                                <span class="text-sm font-medium">{{ field.title }}
                                    @if (field.mandatory) { <span class="opacity-80">*</span> }
                                </span>
                            }

                        <label class="relative inline-flex items-center cursor-pointer select-none">
                        <input
                            type="checkbox"
                            class="sr-only peer"
                            [formControlName]="ctrlName(section.id, field)"
                        />
                        <span
                            class="block h-5 w-9 rounded-full transition-colors duration-150 ease-out"
                            [style.background-color]="
                            isBooleanOn(section.id, field) ? accent() : 'rgba(0,0,0,0.2)'
                            "
                        ></span>
                        <span
                            class="pointer-events-none absolute left-0.5 h-4 w-4 rounded-full bg-white shadow
                                transition-transform duration-150 ease-out
                                peer-checked:translate-x-4"
                        ></span>
                        </label>
                    </div>
                }
 

                @if (field.type === 'map') {

                    <div
                        class="rounded-md border border-black/20 bg-transparent px-3 py-2 flex items-center justify-between gap-3"
                        [class.border-red-500]="showError(section.id, field)"
                        [class.bg-red-50]="showError(section.id, field)"
                        [style.border-radius.px]="cornerRadius()"
                    >
                        <div class="text-sm">
                        @if (mapValue(section.id, field); as v) {
                            <span class="opacity-80">
                            {{ v.lat | number:'1.4-4' }},
                            {{ v.lng | number:'1.4-4' }}
                            </span>
                        } @else {
                            <span class="opacity-60">
                                {{ mapText('noLocation') }}
                            </span>
                        }
                        </div>

                        <button
                        type="button"
                        class="inline-flex items-center gap-1 rounded-full border border-black/15 px-3 py-1.5 text-xs font-medium cursor-pointer hover:bg-black/5"
                        (click)="openMap(section.id, field)"
                        >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-4 h-4"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <path d="M12 21s-5-5.2-5-9a5 5 0 1 1 10 0c0 3.8-5 9-5 9z" />
                            <circle cx="12" cy="12" r="1.8" />
                        </svg>
                        <span>{{ mapText('select') }}</span>
                        </button>
                    </div>

                    @if (showsMap(field)) {
                        <div
                        class="mt-2 h-40 rounded-md border border-current/50 overflow-hidden"
                        [attr.id]="'map-preview-' + section.id + '-' + field.id"
                        ></div>
                    }

                    <input type="hidden" [formControlName]="ctrlName(section.id, field)" />
                }

                @if (showError(section.id, field)) {
                    <div class="text-sm text-red-600" role="alert">
                        {{ getError(section.id, field).join(' ') }}
                    </div>
                }
                
            </div>
            }
            </div>
        </div>
        }

        <!-- MAP MODAL -->
        @if (mapModalOpen()) {
        <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
            <div class="w-[90vw] max-w-xl bg-white rounded-xl shadow-lg overflow-hidden">
                <div class="flex items-center justify-between px-4 py-3 border-b border-black/10">
                    <div class="text-sm font-medium">
                        {{ mapText('chooseLocation') }}
                    </div>
                    <button
                    type="button"
                    class="text-sm opacity-70 hover:opacity-100"
                    (click)="closeMap()"
                    >
                    ✕
                    </button>
                </div>
                <div class="h-[60vh] min-h-[300px] w-full" #mapModalContainer></div>

                <div class="flex justify-end gap-2 px-4 py-3 border-t border-black/10">
                    <button
                    type="button"
                    class="px-3 py-1.5 text-sm cursor-pointer hover:bg-black/5 rounded-md"
                    (click)="closeMap()"
                    >
                        {{ mapText('cancel') }}
                    </button>
                    <button
                    type="button"
                    class="px-3 py-1.5 text-sm text-white rounded-md cursor-pointer hover:opacity-90"
                    [style.background]="accent()"
                    (click)="confirmMapSelection()"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
        }

        @if (hasRequiredFields()) {
        <div class="text-xs opacity-80">
            {{ requiredHint() }}
        </div>
        }
    }
        <!-- PRIMARY BUTTON / SUBMIT -->
        @if (!success()) {
        <button
            type="submit"
            class="w-full py-2 font-semibold cursor-pointer hover:opacity-80"
            [style.background]="submitBtnStyle().background"
            [style.color]="submitBtnStyle().color"
            [style.border-radius.px]="submitBtnStyle().radius"
            [style.border]="submitBtnStyle().borderWidth + 'px solid ' + submitBtnStyle().border"
            style="margin-bottom:15px;"
        >
            {{ (widget()?.submitTitle ?? '') === '' ? 'Submit' : widget()?.submitTitle ?? 'Submit' }}
        </button>
        }

        <!-- SUCCESS MESSAGE (persistent, no auto-hide animation) --> 
        @if (success()) {
        <!-- <div
            class="mt-3 mb-2 text-sm font-semibold text-center p-3 rounded"
            style="background-color: #5cc282; color: #ffffff;"
        >
            {{ widget()?.successMessage ?? 'Form submitted successfully' }}
        </div> -->
        <div style="min-height: 30px;">
            {{ widget()?.successMessage ?? 'Form submitted successfully' }}
        </div>
        }
       
        <!-- SUBMIT AGAIN BUTTON -->
        @if (success() && !$any(widget())?.reloadDPP && widget()?.submitAgainTitle) {
        <div class="mb-2" style="min-height: 55px;">
            <button
                type="button"
                class="w-full mt-3 py-2 font-semibold cursor-pointer hover:opacity-80 flex items-center justify-center gap-2"
                [style.background]="submitBtnStyle().background"
                [style.color]="submitBtnStyle().color"
                [style.border-radius.px]="submitBtnStyle().radius"
                [style.border]="submitBtnStyle().borderWidth + 'px solid ' + submitBtnStyle().border"
                style="margin-bottom:15px;"
                (click)="startAgain()"
            >   
                <div
                [style.width.px]="24"
                [style.height.px]="24"
                [style.background-color]="'currentColor'"
                [style.webkitMask]="'url(assets/icons/repeat.svg) no-repeat center / contain'"
                [style.mask]="'url(assets/icons/repeat.svg) no-repeat center / contain'"
                style="display: inline-block;">
                </div>
                <span>
                {{ widget()?.submitAgainTitle ?? 'Submit again' }}
                </span>
            </button>
        </div>
        }

    </form>
  }
</div>
